var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OrderItem } from '../data/order-item';
import { MathUtils } from '../utility/math-utils';
import { OrderItemBuilder } from './orderitem-builder';
/**
 * A temporary modifier group manager
 * **/
var ModifierBuilder = /** @class */ (function () {
    function ModifierBuilder(store, orderitem, items) {
        if (items === void 0) { items = null; }
        this.items = null;
        /*
    
    {
        "itemId":[
    
            {
                id: "mgroupId"
    
                items: []
    
            },
    
            {
                id: "mgroupId"
                items:[]
            }
        ]
    
    }
    
        */
        this.mods = {};
        this.qmap = {};
        this.pmap = {};
        this.store = store;
        this.orderitem = orderitem;
        this.addExisting();
        var allItems = this.findItems(orderitem);
        if (items) {
            this.items = allItems.filter(function (i) { return items.find(function (ii) { return ii.id === i.id; }) != null; });
        }
        else {
            this.items = allItems;
        }
    }
    ModifierBuilder.prototype.clear = function () {
        this.mods = {};
        this.qmap = {};
        this.pmap = {};
    };
    /**
     * Clear all modifiers selected for specific item and group
     * @param item
     */
    ModifierBuilder.prototype.clearForItem = function (item, group) {
        var _this = this;
        /* this.mods[item.id] = null;
        Object.keys(this.qmap).filter(key => this.isKeyForItem(key, item)).forEach(key => {
            this.qmap[key] = null;
        }) */
        //
        var mgroups = this.mods[this.createModifierMapKey(item)];
        var mgroup = this.findById(mgroups, group.id);
        // let index: number = mgroups.indexOf(mgroup);
        if (!mgroup)
            return;
        if (mgroups) {
            var index = mgroups.indexOf(mgroup);
            mgroups.splice(index, 1);
        }
        mgroup.items.forEach(function (mod) {
            var qkey = _this.createQuantityMapKey(item, mod);
            _this.qmap[qkey] = 0;
            _this.pmap[qkey] = 0;
        });
    };
    ModifierBuilder.prototype.transfer = function (oi) {
        var _this = this;
        if (!oi || !oi.groups) {
            return;
        }
        oi.groups.forEach(function (group) {
            var items = group.items;
            items
                .filter(function (item) { return item.mgroups && item.mgroups.length > 0; })
                .forEach(function (item) {
                var mgroups = item.mgroups;
                mgroups.forEach(function (mgroup) {
                    var mitems = mgroup.items;
                    mitems.forEach(function (mitem) {
                        _this.setMod(item, mgroup, mitem, mitem.quantity);
                    });
                });
            });
        });
    };
    ModifierBuilder.prototype.addExisting = function () {
        var items = OrderItem.getFlattenItems(this.orderitem, false);
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var mgroups = item.mgroups;
            if (mgroups && mgroups.length > 0) {
                for (var _a = 0, mgroups_1 = mgroups; _a < mgroups_1.length; _a++) {
                    var mgroup = mgroups_1[_a];
                    var mods = mgroup.items;
                    if (mods && mods.length > 0) {
                        for (var _b = 0, mods_1 = mods; _b < mods_1.length; _b++) {
                            var mod = mods_1[_b];
                            this.setMod(item, mgroup, mod, mod.quantity, true);
                        }
                    }
                }
            }
        }
    };
    ModifierBuilder.prototype.getQty = function (quantity, mod, ignoreBaseQty) {
        if (ignoreBaseQty === void 0) { ignoreBaseQty = false; }
        var fullmod = this.findItem(mod);
        if (!fullmod)
            return quantity;
        if (quantity == 0 && fullmod.absentId)
            return -1;
        if (!ignoreBaseQty) {
            quantity -= fullmod.baseQty;
        }
        if (quantity < 0)
            quantity = 0;
        return quantity;
    };
    ModifierBuilder.prototype.minus = function (item, group, mItem) {
        var q = this.getQuantity(item, group, mItem);
        if (q > mItem.min) {
            q--;
        }
        this.setMod(item, group, mItem, q);
    };
    ModifierBuilder.prototype.plus = function (item, group, mItem) {
        var q = this.getQuantity(item, group, mItem);
        if (mItem.max > q) {
            q++;
        }
        this.setMod(item, group, mItem, q);
    };
    ModifierBuilder.prototype.setMod = function (item, mgroup, mod, quantity, addExisting) {
        if (addExisting === void 0) { addExisting = false; }
        //var mgroups = this.mods[item.id];
        var mgroups = this.mods[this.createModifierMapKey(item)];
        if (!mgroups) {
            mgroups = [];
            //this.mods[item.id] = mgroups;
            this.mods[this.createModifierMapKey(item)] = mgroups;
        }
        var mg = this.findById(mgroups, mgroup.id); //TODO
        if (!mg) {
            //mg = this.cloneIG(mgroup);
            mg = OrderItemBuilder.cloneIG(mgroup);
            mgroups.push(mg);
        }
        var mods = mg.items;
        var existing = this.findById(mods, mod.id);
        if (!existing) {
            //existing = this.cloneMod(mod);
            existing = OrderItemBuilder.cloneItem(mod);
            mods.push(existing);
        }
        var qty = this.getQty(quantity, mod, addExisting);
        console.log("qty", qty);
        /*
        if (quantity <= 0 && mod.baseQty <= 0) {
            this.removeObject(existing, mods);
        }*/
        var remove = false;
        if (qty == 0) {
            this.removeObject(existing, mods);
            remove = true;
            console.log("remove 0 qty mod");
        }
        if (qty == -1) {
            qty = 0; //need to route to absent item
        }
        existing.quantity = qty;
        if (mods.length == 0) {
            this.removeObject(mg, mgroups);
        }
        var qkey = this.createQuantityMapKey(item, mod);
        if (!remove) {
            this.qmap[qkey] = qty;
            this.pmap[qkey] = MathUtils.round(mod.price * qty, 2);
        }
        else {
            delete this.qmap[qkey];
            delete this.pmap[qkey];
        }
        console.log("qmap", this.qmap);
        console.log("pmap", this.pmap);
    };
    ModifierBuilder.prototype.getPrice = function (item, group, mItem) {
        var qty = this.getQuantity(item, group, mItem);
        if (qty > mItem.baseQty)
            return mItem.price;
        else
            return 0;
    };
    ModifierBuilder.prototype.getTotal = function () {
        var _this = this;
        var total = 0;
        Object.keys(this.pmap).forEach(function (p) {
            total += _this.pmap[p];
        });
        total = MathUtils.round(total, 2);
        return total;
    };
    ModifierBuilder.prototype.createQuantityMapKey = function (item, mod) {
        return item.addTime + "." + item.id + "." + mod.id;
    };
    ModifierBuilder.prototype.createModifierMapKey = function (item) {
        return item.addTime + "." + item.id;
    };
    ModifierBuilder.prototype.getQuantity = function (item, mgroup, mod) {
        var qkey = this.createQuantityMapKey(item, mod);
        var q = this.qmap[qkey];
        if (q == null || isNaN(q)) {
            q = mod.baseQty;
        }
        else {
            if (q > 0)
                q += mod.baseQty;
        }
        return q;
    };
    ModifierBuilder.prototype.getSelectedModifierCount = function (item) {
        var _this = this;
        if (!this.qmap) {
            return 0;
        }
        var count = 0;
        Object.keys(this.qmap)
            .filter(function (key) { return _this.isKeyForItem(key, item); })
            .forEach(function (key) {
            var quantity = _this.qmap[key];
            if (quantity != null && !isNaN(quantity) && quantity > 0) {
                count += quantity;
            }
        });
        return count;
    };
    ModifierBuilder.prototype.isKeyForItem = function (key, item) {
        var parts = key.split(".");
        var itemId = null;
        /*if (parts.length == 2) {
            itemId = parts[0];
        }*/
        var index;
        if (parts.length == 3) {
            itemId = parts[1];
            index = parts[0];
        }
        //return (itemId != null && itemId == item.id);
        return (itemId != null && itemId == item.id && Number(index) == item.addTime);
    };
    ModifierBuilder.prototype.build = function () {
        var items = OrderItem.getFlattenItems(this.orderitem, false);
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            //var mgroups = this.mods[item.id];
            var mgroups = this.mods[this.createModifierMapKey(item)];
            if (mgroups && mgroups.length > 0) {
                item.mgroups = mgroups;
            }
            else {
                item.mgroups = null;
            }
        }
        return this.orderitem;
    };
    ModifierBuilder.build = function (orderitem, imap) {
        if (!imap)
            imap = {};
        orderitem.items.forEach(function (i) {
            var mgroups = i.mgroups;
            if (mgroups && mgroups.length > 0) {
                mgroups.forEach(function (mgroup) {
                    var newItems = [];
                    var original = mgroup.items;
                    original.forEach(function (mitem) {
                        var fullItem = imap[mitem.id];
                        if (mitem.quantity == 0 && fullItem.absentId) {
                            var absent = imap[fullItem.absentId];
                            if (absent) {
                                console.log("replace with absent item", mitem.backendId + "=>" + absent.backendId);
                                var absentItem = OrderItemBuilder.cloneItem(absent);
                                absentItem.quantity = 1;
                                newItems.push(absentItem);
                            }
                            else {
                                console.log("absent item not found", fullItem.absentId);
                            }
                        }
                        else {
                            newItems.push(mitem);
                        }
                    });
                    mgroup.items = newItems;
                });
            }
        });
        OrderItem.flattenItems(orderitem);
        return orderitem;
    };
    ModifierBuilder.prototype.findById = function (list, id) {
        if (!list)
            return null;
        for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
            var o = list_1[_i];
            if (id == o.id) {
                return o;
            }
        }
        return null;
    };
    /*private cloneMod(from: Item): Item {

        var item = new Item();

        item.id = from.id;
        item.name = from.name;
        item.price = from.price;
        item.quantity = 0;
        item.backendId = from.backendId;
        item.extra = from.extra;

        return item;

    }

    private cloneIG(from: ItemGroup): ItemGroup {

        var ig = new ItemGroup();

        ig.id = from.id;
        ig.items = [];
        ig.name = from.name;
        ig.backendId = from.backendId;
        ig.printers = from.printers;

        return ig;

    }*/
    ModifierBuilder.prototype.removeObject = function (object, array) {
        var idx = array.indexOf(object);
        if (idx != -1) {
            array.splice(idx, 1);
        }
    };
    /**
     * Find all modifiable items from current order item
     * @param oi order item
     */
    ModifierBuilder.findItems = function (store, oi) {
        var gmap = store.menu['gmap'];
        //console.log("modifier builder find items", gmap, oi);
        var itemsMap = {};
        for (var _i = 0, _a = oi.groups; _i < _a.length; _i++) {
            var ig = _a[_i];
            var realIg = gmap[ig.id];
            for (var _b = 0, _c = realIg.items; _b < _c.length; _b++) {
                var item = _c[_b];
                itemsMap[item.id] = item;
            }
        }
        var items = OrderItem.getFlattenItems(oi, false);
        var result = [];
        for (var _d = 0, items_3 = items; _d < items_3.length; _d++) {
            var item = items_3[_d];
            //var realItem = itemsMap[item.id]; //!!!reference
            var realItem = __assign({}, itemsMap[item.id]);
            realItem.addTime = item.addTime;
            result.push(realItem);
        }
        //console.log("modable items", result);
        result = result.filter(function (item) {
            var mgroups = item.mgroups;
            if (!mgroups || mgroups.length == 0) {
                return false;
            }
            return mgroups.some(function (mgroup) {
                var mitems = mgroup.items;
                return mitems && mitems.length > 0;
            });
        });
        return result;
    };
    ModifierBuilder.prototype.findItem = function (i) {
        var imap = this.store.menu['imap'];
        if (imap)
            return imap[i.id];
        else
            return null;
    };
    ModifierBuilder.prototype.findItems = function (oi) {
        //let gmap = this.store.menu['gmap'];
        return ModifierBuilder.findItems(this.store, oi);
    };
    return ModifierBuilder;
}());
export { ModifierBuilder };
//# sourceMappingURL=modifier-builder.js.map